<template>
  <div class="cert-signature">
    <Form ref="cert" :label-width="80" style="width:100%">
      <Alert :type="TextType" show-icon>
        {{Text}}
        <span slot="desc">{{TextDesc}}</span>
      </Alert>
      <Select v-model="certSelected" v-if="!reading && certSelectList.length">
        <Option v-for="(item,idx) in certSelectList" :value="idx" :key="idx">[{{ item.displayName }}]{{item.certCn}}</Option>
      </Select>
      <Spin v-if="reading" style="display:flex;align-items: center;justify-content: center;"></Spin>
      <section v-else-if="cert.certSn&&!cert.sign">
        <div class="padding-top-10"></div>
        <Button type="primary" :disabled="!SubmitEnable" :loading="submitting" @click="topESA_Sign" long>签名</Button>
      </section>
      <section v-else>
        <Button @click="init" type="error" ghost long>再试一次</Button>
        <!-- <Button long @click="mockBidder">Mock Bidder</Button>
        <Button long @click="mockGuarantor">Mock Guarantor</Button> -->
      </section>
    </Form>
  </div>
</template>

<script>
import {
  Certificate,
  Pkcs7,
  CertStore,
  TCACore,
  TCACErr
} from './../../public/static/TopESA/topEsa.min.js'

export default {
  name: 'cert-signature',
  props: {
    mode: String, // bin|normal
    dataToSign: String
  },
  data () {
    return {
      reading: false,
      aAgent: '',
      SignCert: '',
      acceptAgents: [
        { displayName: '河南CA', caAgent: 'HNCA', agentCN: ['HNCA'] },
        { displayName: '信安CA', caAgent: 'XACA', agentCN: ['XACA', 'HNXACA'] },
        { displayName: '天威诚信', caAgent: 'TopESA', agentCN: ['思创网联（北京）科技发展有限公司CA'] } // 天威诚信RSA测试用户CA
      ],
      certSelectList: [],
      cert: {
        raw: '',
        time: '',
        mD5: '',
        certSn: '',
        sign: ''
      },
      Text: '',
      TextDesc: '',
      TextType: 'success',
      SubmitEnable: true,
      submitting: false,
      certSelected: null
    }
  },
  watch: {
    dataToSign: function (newVal) {
      this.cert.raw = newVal
    },
    'cert.Cert': function (newVal) {
      if (newVal) {
        this.SubmitEnable = true
      }
    },
    certSelected: function (newVal) {
      if (newVal) {
        let cert = this.certSelectList[newVal]
        this.caAgent = cert.caAgent
      } else {
        this.caAgent = null
      }
    }
  },
  mounted () {
    this.cert.raw = this.dataToSign
    this.init()
  },
  methods: {
    init () {
      this.caAgent = ''
      this.certSelectList = []
      this.cert.time = ''
      this.cert.mD5 = ''
      this.cert.certSn = ''
      this.cert.sign = ''
      this.reading = true
      this.Text = '正在寻找UKey...'
      this.TextType = 'info'
      this.TextDesc = '请确认UKey已插入计算机...'
      this.getCACertList((err) => {
        if (err) {
          this.TextType = 'error'
          this.Text = '未检测到UKey'
          this.TextDesc = err.message
          this.reading = false
          return false
        }
        switch (this.caAgent) {
          case 'TopESA':
            this.topESA_InitCertList()
            break
          default:
            this.TextType = 'error'
            this.Text = '未检测到UKey...'
            this.TextDesc = '请确认UKey是否正确插入计算机...'
            this.reading = false
            break
        }
      })
    },
    getCnFromString (str) {
        let cnIndex = str.indexOf('CN=') // 获取CN项位置
        let stringCN = str.substring(cnIndex + 3, str.length)  // 将CN项前的信息去除
        let subjectIndexComma = stringCN.indexOf(',') // 第1个逗号所在位置
        if (subjectIndexComma !== -1) { // 如果'CN='后仍有内容
          stringCN = stringCN.substring(0, subjectIndexComma)
        }
        return stringCN
    },
    getCACertList (callback) {
      try {
        this.certSelectList = []
        let certs = TCACore.getInstance().call('CertStore/listCerts', '{"certStoreName" : "MY", "needB64" : true}')
        if (certs.certArr.length > 0) {
          for (let i = 0; i < certs.certArr.length; i++) {
            let cert = certs.certArr[i]
            // console.log(cert)
            let serialNumber = cert.SN
            let subject = cert.subject.dn
            let subjectCN = this.getCnFromString(subject)
            let issuer = cert.issuer.dn
            let issuerCN = this.getCnFromString(issuer)
            this.acceptAgents.forEach((item) => {
              let exists = this.certSelectList.findIndex(o => o.certSn === serialNumber)
              if (item.agentCN.indexOf(issuerCN) >= 0 && exists === -1) {
                Object.assign(item, {
                  issuer: issuerCN,
                  certCn: subjectCN,
                  certSn: serialNumber,
                  certBase64: cert.b64
                })
                console.log(item)
                this.certSelectList.push(item)
              }
            })
          }
        }
        if (this.certSelectList.length > 0) {
          this.certSelected = 0
          this.caAgent = this.certSelectList[0].caAgent
        }
        if (callback) {
          callback(null, true)
        }
      } catch (e) {
        if (e instanceof TCACErr) {
          if (callback) {
            callback(new Error(e.description))
          }
          return 'Error'
        }
        if (callback) {
          callback(e)
        }
        return 'Error'
      }
    },
    topESA_InitCertList () {
      try {
        var certs = CertStore.listAllCerts()
        if (certs.size() > 0) {
          for (var i = 0; i < certs.size(); i++) {
            var cert = certs.get(i)
            var sn = cert.serialNumber()
            var cn = this.topESA_GetCNFromSubject(cert)
            var issuer = this.getCnFromString(cert.issuer())
            this.cert.issuer = issuer
            this.cert.certSn = sn
            this.cert.certCn = cn
            this.cert.certBase64 = cert.toBase64()      // public key
            this.TextType = 'info'
            this.TextDesc = ''
            this.Text = '证书读取成功！'
          }
        } else {
          this.TextType = 'error'
          this.TextDesc = ''
          this.Text = '未检测到UKey...'
        }
        this.reading = false
      } catch (e) {
        if (e instanceof TCACErr) {
          this.TextType = 'error'
          this.Text = '发生错误'
          this.TextDesc = e.toStr()
        } else {
          this.TextType = 'error'
          this.TextDesc = ''
          this.Text = '读取证书错误'
        }
        this.reading = false
      }
    },
    topESA_GetCNFromSubject (cert) {
      try {
        var t = cert.subject().match(/(S(?!N)|L|O(?!U)|OU|SN|CN|E)=([^=]+)(?=, |$)/g)
        for (var i = 0; i < t.length; i++) {
          if (t[i].indexOf('CN=') === 0) {
            return t[i].substr(3, t[i].length)
          }
        }
        return null
      } catch (e) {
        if (e instanceof TCACErr) {
          this.TextType = 'error'
          this.TextIcon = 'close'
          this.Text = e.toStr()
        } else {
          this.TextType = 'error'
          this.TextIcon = 'close'
          this.Text = '读取证书错误'
        }
      }
    },
    topESA_GetSelectedCert () {
      try {
        var certs = CertStore.listAllCerts()  // 此处可能会有性能问题
        var selectedCertSN = this.cert.certSn
        var r = certs.bySerialnumber(selectedCertSN)
        return r.get(0)
      } catch (e) {
        if (e instanceof TCACErr) {
          this.TextType = 'error'
          this.TextIcon = 'close'
          this.Text = e.toStr()
        } else {
          this.TextType = 'error'
          this.TextIcon = 'close'
          this.Text = '没有找到证书'
        }
      }
    },
    async topESA_Sign () {
      try {
        this.SignBtnEnabled = false
        let cert = this.topESA_GetSelectedCert()
        if (this.mode === 'bin') { // 二进制签名
          let sign = ''
          this.cert.time = new Date().toISOString()
          this.cert.mD5 = this.$md5(this.cert.raw)
          sign = cert.signMessageBinRaw(this.cert.raw)
          this.cert.sign = sign
          this.$emit('cert-verified', this.cert)
        } else {
          console.log(this.cert)
          this.cert.time = new Date().toISOString()
          this.cert.mD5 = this.$md5(this.cert.raw)
          // cert.signMessage(str, includeOriginalText) P7签名
          this.cert.sign = cert.signMessageRaw(this.$md5(this.cert.raw))
          this.$emit('cert-verified', this.cert)
        }
      } catch (e) {
        if (e instanceof TCACErr) {
          this.TextType = 'error'
          this.TextIcon = 'close'
          this.Text = e.toStr()
        } else {
          this.TextType = 'error'
          this.TextIcon = 'close'
          this.Text = '签名错误'
        }
      }
    },
    topESA_encrypt () {
      try {
        var toEnc = '需加密原文'
        var cert = this.topESA_GetSelectedCert()
        // 获取公钥信息
        // 证书已经安装到浏览器的情况，可以通过下面的方法直接获取证书的公钥信息
        var certBase64 = cert.toBase64()
        // 证书没有安装浏览器的情况，该信息为要加密信息公钥证书的BASE64编码
        // var certBase64='MIIEBjCCAu6gAwIBAgIUEcq11Y+wc+nwqdf81SesGhuvcd8wDQYJKoZIhvcNAQELBQAwbDEmMCQGA1UEAwwd5aSp5aiB6K+a5L+hUlNB5rWL6K+V55So5oi3Q0ExEjAQBgNVBAsMCVJTQea1i+ivlTEhMB8GA1UECgwY5aSp5aiB6K+a5L+h5rWL6K+V57O757ufMQswCQYDVQQGEwJDTjAeFw0xNzA3MDMwODMyNDBaFw0xODA3MDMwODMyNDBaMEcxGDAWBgNVBAoMD+WkqeWogeivmuS/oVJTQTELMAkGA1UECwwCUkExHjAcBgNVBAMMFVZQTumbhuaIkOa1i+ivleivgeS5pjCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBAKupBzCAuB/pxVPZ7LIdYUyqaAHFFyhKCFnYdQ4I7+2qZpabt6gdSk7qTzHnhN+mEu3tm4TVai3Aa4Nvh9Gm2LgcPmwLtWpGQ/Xui4q69J6V2H6f+goGMPAJXENMxH4F2SrzW9Gmsz2q/IjaNdtu93HKT5OAqaFsyafbr7WR45HcCHekFVVonWzLgAyzoe+W36Ue9K/OODRDojYhaDeCp+0MYnUtIkgAtExCRopBrxvqMSBhH49fy1epPbwghPQPOYHkUlj0mKXkX2DeminSuMxEMCf4RpraL9/jVfrzSRC9djk+11DZfWWD5egi40xbqNpn4qgZp5imH+YW6KR/yGcCAwEAAaOBxDCBwTAJBgNVHRMEAjAAMAsGA1UdDwQEAwIE8DBnBgNVHR8EYDBeMFygWqBYhlZodHRwOi8vaXRydXNkZW1vLmNvbS9Ub3BDQS9wdWJsaWMvaXRydXNjcmw/Q0E9MDIwOUE2QkFGODhFRTI1OUFCREM3ODYwMEIyOTkzMTQzMjNBQTU3NDAfBgNVHSMEGDAWgBS0bmWRkUvRe8Ggn6Q+fc9X4LUuSDAdBgNVHQ4EFgQUQWvU5heh2UiVpyvnsw6EUG/oFCIwDQYJKoZIhvcNAQELBQADggEBAEK3psFJT8KhbfkoeBRSFesMaEAgNWgmJ2UczZlKao7V2ibIycKFtwFmPYMWQuIygCcZAmYfdnnGhPNWS+Va8zam1vxV4WJS1va7obeD/ZRP7LLNmUwHjxToBwxGLAmu5nhuhChD90Vxw0yptsnR8FFI/uPbDIimLixqpRx44vfyT6cOT8uRXIsTFBsrgTDKWpWFy1G1/eTQBYOxCH0t20/Yzs2tcmR+CsXfEar4rnAQJlVDo7vNbEglQMrkiR0dTIZYRk0L1cYzkVuEXlGjphmxaK0Wdy+bCVZuAJY08U36qQH3qXs1hQeIRFGbuPlT7YUR7iKZhqK9WJY9kWuS7wI=';
        var publicCert = new Certificate(certBase64)
        var P7 = publicCert.encryptMessage(toEnc)
        console.log(P7)
      } catch (e) {
        if (e instanceof TCACErr) {
          alert(e.toStr())
        } else {
          alert('Here is Error !!!')
        }
      }
    },
    topESA_decrypt () {
      try {
        var b64 = '密文'
        var P7 = new Pkcs7(b64)
        var result = P7.decryptMessage()
        console.log(result)
      } catch (e) {
        if (e instanceof TCACErr) {
          alert(e.toStr())
        } else {
          alert('Here is Error !!!')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>
